import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <React.StrictMode>
        <script src="https://accounts.google.com/gsi/client" async></script>

        <App />
    </React.StrictMode>,
)
